import { provideTellentAssistantRenderPresenter } from '@core/tellent-assistant-contracts';
import type {
  PresentCandidatesArgs,
  PresentEvaluationsArgs,
  PresentEventsArgs,
  PresentJobsArgs,
  PresentLinksArgs,
  PresentRequisitionsArgs,
  PresentSourcesArgs,
  PresentTalentPoolsArgs,
  PresentTasksArgs,
  PresentTeamMembersArgs,
} from '@core/tellent-assistant-types';

import {
  PresentCandidatesComponent,
  PresentEvaluationsComponent,
  PresentEventsComponent,
  PresentJobsComponent,
  PresentLinksComponent,
  PresentRequisitionsComponent,
  PresentSourcesComponent,
  PresentTalentPoolsComponent,
  PresentTasksComponent,
  PresentTeamMembersComponent,
} from '../present-list/kinded-presenters.component';

export const providePresentCandidatesClientTool =
  provideTellentAssistantRenderPresenter<PresentCandidatesArgs>({
    id: 'presentCandidates',
    component: PresentCandidatesComponent,
  });

export const providePresentTeamMembersClientTool =
  provideTellentAssistantRenderPresenter<PresentTeamMembersArgs>({
    id: 'presentTeamMembers',
    component: PresentTeamMembersComponent,
  });

export const providePresentJobsClientTool = provideTellentAssistantRenderPresenter<PresentJobsArgs>(
  {
    id: 'presentJobs',
    component: PresentJobsComponent,
  },
);

export const providePresentTalentPoolsClientTool =
  provideTellentAssistantRenderPresenter<PresentTalentPoolsArgs>({
    id: 'presentTalentPools',
    component: PresentTalentPoolsComponent,
  });

export const providePresentLinksClientTool =
  provideTellentAssistantRenderPresenter<PresentLinksArgs>({
    id: 'presentLinks',
    component: PresentLinksComponent,
  });

export const providePresentSourcesClientTool =
  provideTellentAssistantRenderPresenter<PresentSourcesArgs>({
    id: 'presentSources',
    component: PresentSourcesComponent,
  });

export const providePresentEventsClientTool =
  provideTellentAssistantRenderPresenter<PresentEventsArgs>({
    id: 'presentEvents',
    component: PresentEventsComponent,
  });

export const providePresentEvaluationsClientTool =
  provideTellentAssistantRenderPresenter<PresentEvaluationsArgs>({
    id: 'presentEvaluations',
    component: PresentEvaluationsComponent,
  });

export const providePresentTasksClientTool =
  provideTellentAssistantRenderPresenter<PresentTasksArgs>({
    id: 'presentTasks',
    component: PresentTasksComponent,
  });

export const providePresentRequisitionsClientTool =
  provideTellentAssistantRenderPresenter<PresentRequisitionsArgs>({
    id: 'presentRequisitions',
    component: PresentRequisitionsComponent,
  });
